import React, { Component, LegacyRef } from 'react';
import isEqual from 'lodash.isequal';
import { KanbanProps } from './types';

export default class KanbanComponent extends Component<KanbanProps> {
  onRef: LegacyRef<HTMLElement> = (node) => {
    if (node) {
      if (this.props.inputs) {
        Object.assign(node, this.props.inputs);
      }
      if (this.props.outputs) {
        const { outputs } = this.props;
        const eventNames = Object.keys(outputs);
        for (const eventName of eventNames) {
          node.addEventListener(eventName, outputs[eventName] as EventListener);
        }
      }
    }
  };
  // Допускаем обновление компонента только в случае если измененились props,
  // если родительский компонент перерендерился, этот не должен вызывать у себя апдейт
  shouldComponentUpdate(nextProps: KanbanProps) {
    if (isEqual(this.props, nextProps)) {
      return false;
    }
    return true;
  }

  render() {
    return React.createElement('nim-tasks-board', { ref: this.onRef, key: 'kanban-custom-component-' + Math.random() });
  }
}
